module.exports = __webpack_public_path__ + "static/media/Notifications.cb6f2a66.svg";